module.exports = __webpack_public_path__ + "img/font.95861caf.png";